// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-xs{padding:.5rem;font-size:75%;line-height:1;border-radius:1rem}.lb-header{position:fixed;top:0;right:0;left:0;z-index:95}.lb-header #main-menu{margin-left:20rem;transition:all .6s cubic-bezier(.945,.02,.27,.665);transform-origin:center left}.lb-header #main-menu.aside-closed{margin-left:5.5rem}", ""]);
// Exports
module.exports = exports;
